import React from "react";

function TaskIcon({width, height}) {
  return (
    <div>
      <svg
        version="1.1"
        width={width}
        height={height}
        x="0"
        y="0"
        viewBox="0 0 100 100"
      >
        <g>
          <path
            fill="#fdbe00"
            d="M76.162 27.258a6.385 6.385 0 0 0-6.384-6.387H30.572a6.386 6.386 0 0 0-6.384 6.387v51.565a6.386 6.386 0 0 0 6.384 6.387h39.206a6.385 6.385 0 0 0 6.384-6.387V27.258z"
            opacity="1"
            data-original="#fdbe00"
          />
          <path
            fill="#575c69"
            d="M44.626 84.46H30.685a5.636 5.636 0 0 1-5.634-5.637V46.418a.75.75 0 1 0-1.5 0v32.405a7.136 7.136 0 0 0 7.134 7.137h13.941a.75.75 0 1 0 0-1.5z"
            opacity="1"
            data-original="#575c69"
          />
          <path
            fill="#ddeaf3"
            d="M71.26 27.445c0-.974-.79-1.763-1.765-1.763H31.117c-.975 0-1.766.79-1.766 1.763v50.956c0 .975.791 1.764 1.766 1.764h38.378c.975 0 1.765-.79 1.765-1.764V27.445z"
            opacity="1"
            data-original="#ddeaf3"
          />
          <path
            fill="#bccdd9"
            d="M71.178 65.317 56.295 80.2h13.118c.975 0 1.765-.791 1.765-1.765z"
            opacity="1"
            data-original="#bccdd9"
          />
          <path
            fill="#f2f7fb"
            d="m56.295 80.2 14.883-14.883H58.06c-.975 0-1.765.791-1.765 1.765z"
            opacity="1"
            data-original="#f2f7fb"
          />
          <path
            fill="#ff5d14"
            d="M61.449 22.151a4.06 4.06 0 0 0-4.06-4.061H42.962a4.061 4.061 0 0 0-4.06 4.061v4.668a2.378 2.378 0 0 0 2.378 2.378H59.07a2.378 2.378 0 0 0 2.378-2.378v-4.668z"
            opacity="1"
            data-original="#ff5d14"
          />
          <circle
            cx="251.784"
            cy="344.905"
            r="4.447"
            fill="#ff5d14"
            transform="translate(-257.981 -402.211) scale(1.224)"
            opacity="1"
            data-original="#ff5d14"
          />
          <circle
            cx="251.784"
            cy="344.905"
            r="4.447"
            fill="#575c69"
            transform="matrix(.455 0 0 .455 -64.251 -136.831)"
            opacity="1"
            data-original="#575c69"
          />
          <path
            fill="#575c69"
            d="M41.2 39.098h23.638a.75.75 0 0 0 0-1.5H41.2a.751.751 0 0 0 0 1.5zM36.632 46.741h28.285a.75.75 0 0 0 0-1.5H36.632a.751.751 0 0 0 0 1.5zM36.632 54.384h28.285a.75.75 0 0 0 0-1.5H36.632a.751.751 0 0 0 0 1.5zM36.473 62.027h18.946a.75.75 0 0 0 0-1.5H36.473a.751.751 0 0 0 0 1.5zM57.142 80.973l10.24-10.181a.749.749 0 1 0-1.057-1.063l-10.24 10.18a.75.75 0 0 0 1.057 1.064z"
            opacity="1"
            data-original="#575c69"
          />
        </g>
      </svg>
    </div>
  );
}

export default TaskIcon;
